import * as React from "react";
const SvgFiRrEscalator = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-escalator_svg__a)">
      <path
        fill="#062147"
        d="M6 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m18 6.452c0 2.159-1.594 3.865-3.617 4.034L9.044 22.58A6 6 0 0 1 5.169 24H3.951A3.956 3.956 0 0 1 0 20.048c0-2.159 1.594-3.865 3.617-4.034L5 14.844V9.5C5 7.57 6.57 6 8.5 6a3.506 3.506 0 0 1 3.458 2.957l2.998-2.537A6 6 0 0 1 18.831 5h1.218A3.956 3.956 0 0 1 24 8.952m-17 4.2 3-2.538V9.501c0-.827-.673-1.5-1.5-1.5S7 8.674 7 9.501zm15-4.104C22 7.875 21.125 7 20.049 7h-1.218c-.944 0-1.862.336-2.584.947L4.645 17.763a1 1 0 0 1-.646.237c-1.125 0-2 .875-2 1.952 0 1.173.875 2.048 1.951 2.048h1.218c.944 0 1.862-.336 2.584-.947l11.602-9.816A1 1 0 0 1 20 11c1.125 0 2-.875 2-1.952"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-escalator_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEscalator;
